import type { useI18n } from "vue-i18n";

type Translate = ReturnType<typeof useI18n>["t"];
type TranslationExists = ReturnType<typeof useI18n>["te"];

export interface SidebarLabelSource {
  key: string
  name: string | null
}

/**
 * `translationKey` on a view points at the list header (`tasks.type.*`, contains `{count}`),
 * so the sidebar resolves its own label per built-in key. Custom or renamed views use `name`.
 */
export function resolveViewSidebarLabel(
  view: SidebarLabelSource,
  sidebarLabelKeys: Record<string, string>,
  t: Translate,
  te: TranslationExists,
): string {
  if (view.name) {
    return view.name;
  }
  const labelKey = sidebarLabelKeys[view.key];
  if (labelKey && te(labelKey)) {
    return t(labelKey);
  }
  return view.key;
}
